import { Stack } from '@mui/material';

import { smsStep1Data } from 'src/utils/constants';

import { useTranslate } from 'src/locales';
import { useChannelContext } from 'src/pages/channel/hooks';
import { ProviderList, ChannelStepLayout } from 'src/pages/channel/shared';

export function SMSStep2() {
  const { t } = useTranslate('translation');
  const { state: channelState, onSMSProvider, onChangeStep } = useChannelContext();

  const isNextDisabled = !channelState.SMSProviderType;

  const handleDoubleClick = (value: string) => {
    onSMSProvider(value);
    onChangeStep('next');
  };

  return (
    <Stack spacing={4} sx={{ height: '100%' }}>
      <ChannelStepLayout
        title={t('CHOOSE_YOUR_SMS_PROVIDER')}
        subtitle={t('SELECT_SMS_PROVIDER')}
        isNextDisabled={isNextDisabled}
      >
        <ProviderList
          providers={smsStep1Data(t)}
          selectedProvider={channelState.SMSProviderType}
          onSelect={onSMSProvider}
          onDoubleClick={handleDoubleClick}
        />
      </ChannelStepLayout>
    </Stack>
  );
}
